import React from 'react'

import { Avatar } from '../atoms'
import { AuthUserProps } from './AuthUser.types'

import { useAuthenticatedApiClient } from '../hooks'

export const AuthUser: React.FC<AuthUserProps> = (config) => {
  const { authUser } = useAuthenticatedApiClient(config)

  return (
    <Avatar
      alt={authUser && authUser.name}
      src={authUser && authUser.picture}
      href={authUser && `https://app.pollination.cloud/${authUser.username}`}
      fallback={authUser
        && (authUser.name.split(' ').length > 1
          ? authUser.name.split(' ').map((n) => n.charAt(0).toUpperCase()).join('')
          : authUser.name.slice(0, 2).toUpperCase())}
    />
  )
}

export default AuthUser